import { ApiError } from "./api";

const TECHY = /^(HTTP\s|Failed to|TypeError|NetworkError)/i;

/**
 * Traduce cualquier fallo a un mensaje humano en español, sin códigos HTTP a la vista.
 * Los mensajes del backend se usan solo cuando ya vienen en lenguaje natural.
 */
export function humanizeError(error: unknown): string {
  if (error instanceof ApiError) {
    switch (error.status) {
      case 0:
        return humanMessage(error, "No pudimos conectar. Revisa tu conexión a internet.");
      case 401:
        if (error.code === "operator_key_expired") {
          return "La clave de tu empresa venció. Escríbenos para renovarla.";
        }
        if (error.code === "operator_key_revoked") {
          return "La clave de tu empresa fue revocada. Escríbenos para emitir una nueva.";
        }
        return "La clave de tu empresa no es válida. Revísala en Ajustes.";
      case 403:
        return "Esta operación no está permitida con la clave actual.";
      case 404:
        return humanMessage(error, "No encontramos lo que buscabas.");
      case 405:
        return "No pudimos completar esta acción.";
      case 409:
        return humanMessage(error, "Ese recurso ya está en uso.");
      case 410:
        return "Ese código ya venció. Genera uno nuevo.";
      case 413:
        return "La solicitud es demasiado grande.";
      case 429:
        return "Estamos recibiendo muchas solicitudes. Espera unos segundos.";
      default:
        return error.status >= 500
          ? "Tuvimos un problema. Intenta de nuevo en unos segundos."
          : humanMessage(error, "No pudimos completar la operación. Intenta de nuevo.");
    }
  }
  if (error instanceof TypeError) {
    return "No pudimos conectar. Revisa tu conexión a internet.";
  }
  if (error instanceof Error) return humanMessage(error, "Ocurrió un problema inesperado.");
  return "Ocurrió un problema inesperado.";
}

function humanMessage(error: Error, fallback: string): string {
  const message = error.message.trim();
  if (message === "" || TECHY.test(message) || /https?:\/\//.test(message)) return fallback;
  if (error instanceof ApiError && (error.code === "invalid_response" || error.code === "timeout")) {
    return fallback;
  }
  return message;
}

export const GEOLOCATION_MESSAGES: Record<number, string> = {
  1: "El navegador no tiene permiso para usar tu ubicación. Puedes marcar el hogar en el mapa.",
  2: "No pudimos obtener tu ubicación ahora. Marca el hogar directamente en el mapa.",
  3: "La ubicación tardó demasiado. Intenta de nuevo o marca el hogar en el mapa.",
};
